import { getItemByField } from "../../../../../web-graphics";
import { SettingsParser } from "./settings-parser";
import { VisualizatorCoreSettings } from "../settings/visualizator-core-settings";

export class VisualizatorSettingsParser extends SettingsParser {
  constructor(modeSettingsParser, dataParser, viewParser) {
    super();
    this.parsedFieldNames = ["configVersion", "mode", "modeSettings", "data", "view"];
    this.modeSettingsParser = modeSettingsParser;
    this.dataParser = dataParser;
    this.viewParser = viewParser;
  }

  static createSettings(settings, defaultSettings, modeSettingsParser, dataParser, viewParser) {
    if (settings === undefined) {
      return undefined;
    }
    let parsedSettings = {
      configVersion: settings.configVersion,
      mode: settings.mode ?? defaultSettings?.mode ?? "release",
      modeSettings: new Map()
    };
    if (modeSettingsParser !== undefined && settings.modeSettings !== undefined && Array.isArray(settings.modeSettings)) {
      let modeDefaultSettingsList = [];
      if (defaultSettings?.modeSettings !== undefined) {
        modeDefaultSettingsList = defaultSettings.modeSettings;
      }

      for (let i = 0; i < settings.modeSettings.length; i++) {
        let modeName = settings.modeSettings[i].mode;
        let modeDefaultSettings = getItemByField("mode", modeName, modeDefaultSettingsList);
        let modeSettings = modeSettingsParser.parse(settings.modeSettings[i], modeDefaultSettings);
        if (modeSettings !== undefined) {
          parsedSettings.modeSettings.set(modeName, modeSettings);
        }
      }
    }
    if (dataParser !== undefined && settings.data !== undefined) {
      parsedSettings.data = dataParser.parse(settings.data, defaultSettings?.data);
    }
    if (viewParser !== undefined && settings.view !== undefined) {
      parsedSettings.view = viewParser.parse(settings.view, defaultSettings?.view);
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = VisualizatorSettingsParser.createSettings(
      settings,
      defaultSettings,
      this.modeSettingsParser,
      this.dataParser,
      this.viewParser
    );
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new VisualizatorCoreSettings(parsedSettings);
  }
}
